import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_p9ea6rv64x: FaireBrandEntity = {
  token: "b_p9ea6rv64x",
  type: "brand",
  name: "La Lune Healing",
  avatarUrl:
    "https://cdn.faire.com/fastly/76abde47997f788c3c1537899bd888546bf42ce927f0a866fc4f877c87960916.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/50e20bee0aaac65121b7dbae1c5cd17d581ec102c46f44c4d7f739d1ba64c764.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/76abde47997f788c3c1537899bd888546bf42ce927f0a866fc4f877c87960916.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/50e20bee0aaac65121b7dbae1c5cd17d581ec102c46f44c4d7f739d1ba64c764.jpeg",
  location: "Newport, RI, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isTopShop: true,
  isInsider: true,
  description:
    "Meet Lindsey, creator and founder of La Lune Healing. A wellness company focused on providing guidance and healing. Along with curating self-care items to help support and align you on your self-care journey.\n\nOur Unique products were created to enhance your healing journey. We make it easy to incorporate daily rituals by using our handmade line. We focus on using simple and pure ingredients, free from toxic fragrance. \n\nUsing vegan, eco friendly material with honest transparency, we are committed to making products that not only heal on a spiritual level, but are fun and easy to use! \n\nAll items are Reiki Energy charged and Crystal infused for high vibrational frequency. Hand made and hand dyed giving each product a unique look and feel. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:18.786Z",
    importedBy: "entity-db-cli",
  },
};
